__turbopack_context__.v({
  "className": "_57RtGa_className",
  "variable": "_57RtGa_variable",
});
